import { FC, useCallback, useEffect, useState } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { subMonths, format, addMonths } from 'date-fns';

import FeedPage from './FeedPage';
import HotPage from './HotPage';
import HotPledgePage from './HotPledgePage';

import { ChevronLeftIcon } from '@components/elements/Icons';
import DatePicker from '@components/elements/DatePicker';
import Tabs, { Tab } from '@components/elements/Tabs';

type FeedTabValue = '/' | '/polls/hot' | '/pledges/hot';

const TABS: Tab[] = [
  {
    label: 'Your feed',
    value: '/',
  },
  {
    label: 'Hot polls',
    value: '/polls/hot',
  },
  {
    label: 'pledges',
    value: '/pledges/hot',
  },
  {
    label: 'Ideas',
    value: '/idealist',
  },
];

const BASE_PATH = '/feed';

const PollRouter: FC = () => {
  const history = useHistory<any>();

  const [currentTab, setCurrentTab] = useState<FeedTabValue | string>('/');
  const [filterDate, setFilterDate] = useState<Date>(new Date());

  useEffect(() => {
    let nextTab: FeedTabValue = '/';
    const subroute = history?.location.pathname.split(BASE_PATH)[1];
    if (subroute === '/polls/hot') nextTab = '/polls/hot';
    if (subroute === '/pledges/hot') nextTab = '/pledges/hot';

    setCurrentTab(nextTab);
  }, [history.location.pathname]);

  const onChangeTab = useCallback(
    (tab: Tab) => {
      if (tab.value !== currentTab) {
        setCurrentTab(tab.value.toString());
        history.replace(
          tab.value === '/idealist' ? tab.value : `${BASE_PATH}${tab.value}`
        );
      }
    },
    [history, currentTab]
  );

  const controls = (
    <>
      <Tabs
        className="flex-row mb-8 xl:flex-col xl:mb-4"
        active={{ value: currentTab }}
        tabs={TABS}
        onChange={onChangeTab}
      />
      <Switch>
        <Route exact path={`${BASE_PATH}`}>
          <h1 className="pb-2">
            <div className="text-2xl font-bold uppercase">Polls In</div>
            <DatePicker
              end={addMonths(new Date(), 3)}
              start={subMonths(new Date(), 6)}
              value={filterDate}
              interval="month"
              title="Filter Polls in Month"
              dateFormat="y MMMM"
              onChange={(v) => {
                if (v) setFilterDate(v);
              }}
            >
              <div
                className="flex flex-row items-center justify-between px-2 py-1 text-4xl font-bold text-black duration-300 border-black border-3 transition-color hover:text-white hover:border-magenta hover:bg-magenta"
                role="button"
              >
                <div>{format(filterDate, 'MMMM yyyy')}</div>
                <ChevronLeftIcon className="transform -rotate-90" />
              </div>
            </DatePicker>
          </h1>
        </Route>
        <Route path={`${BASE_PATH}/polls/hot`}>
          <h1 className="pb-2 text-4xl font-bold">
            <span className="px-2 text-green bg-magenta">Hot</span>
            &nbsp;
            <span>Polls</span>
          </h1>
        </Route>
        {/* <Route path={`${BASE_PATH}/pledges/hot`}>
          <UpcomingNotice />
        </Route> */}
      </Switch>
    </>
  );
  return (
    <div
      className="h-screen pt-20 overflow-x-hidden overflow-y-scroll bg-fixed bg-cyan bracket-pattern-cyan xl:pt-0"
      id="ok1"
    >
      <div className="flex flex-col gap-4 mx-auto xl:container xl:gap-0 xl:flex-row">
        <div className="w-full p-4 xl:min-h-screen xl:sticky xl:top-0 xl:w-72">
          {controls}
        </div>
        <div className="flex flex-1">
          <div className="flex-1 pb-24 xl:pb-0 lg:pt-4">
            <Switch>
              <Route exact path={`${BASE_PATH}`}>
                <FeedPage filterDate={filterDate} />
                {/* <NewPage /> */}
              </Route>
              <Route path={`${BASE_PATH}/polls/hot`}>
                <HotPage />
              </Route>
              <Route path={`${BASE_PATH}/pledges/hot`}>
                <HotPledgePage />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export * from './FeedPage';
export default PollRouter;
